import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, FreeMode } from "swiper/modules";
import { Link } from "react-router-dom";
import "./finance-partners.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";

const FinancePartners = () => {
  const partners = [
    { name: "Axis Bank", image: "axisbank.jpg" },
    { name: "HDFC Credila", image: "HDFC-Credilia.jpg" },
    { name: "IDFC First", image: "IDFC-First.jpg" },
    { name: "SBI", image: "SBI.jpg" },
    { name: "NBFC", image: "NBFC.jpg" },
  ];

  return (
    <section className="py-5 finance-partners">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold">Finance Partners</h2>
        </div>

        <Swiper
          modules={[Autoplay, Navigation, FreeMode]}
          loop={true}
          freeMode={true}
          speed={1000}                  
          autoplay={{ delay: 2000 }}
          navigation={false}
          spaceBetween={30}
          slidesPerView={5}
          breakpoints={{
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
          className="finance-slider"
        >
          
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <div className="finance-logo-wrap">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/${partner.image}`}
                  alt={partner.name}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="text-center mt-4">
          <Link to="#" className="view-all-link">
            View All Partners →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinancePartners;
